import { LocalStorageService } from './localStorageService';

const localStorageService = new LocalStorageService();

export { localStorageService };
